// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.announcementspg-inline-1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.announcementspg-inline-2 {
  margin-bottom: 0;
}

.announcementspg-inline-3 {
  padding: 0;
}

.announcementspg-inline-4 {
  font-weight: 600;
}

.announcementspg-inline-5 {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.announcementspg-inline-6 {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 12px;
}

.announcementspg-inline-7 {
  white-space: pre-wrap;
  line-height: 1.6;
  color: #334155;
}

.announcementspg-inline-8 {
  margin-top: 16px;
  font-size: 12px;
  color: #64748b;
}

.announcementspg-dyn-1 {
  cursor: var(--announcementspg-1-cursor);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/HR/AnnouncementsPg.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uCAAuC;AACzC","sourcesContent":[".announcementspg-inline-1 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.announcementspg-inline-2 {\n  margin-bottom: 0;\n}\n\n.announcementspg-inline-3 {\n  padding: 0;\n}\n\n.announcementspg-inline-4 {\n  font-weight: 600;\n}\n\n.announcementspg-inline-5 {\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.announcementspg-inline-6 {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 12px;\n}\n\n.announcementspg-inline-7 {\n  white-space: pre-wrap;\n  line-height: 1.6;\n  color: #334155;\n}\n\n.announcementspg-inline-8 {\n  margin-top: 16px;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.announcementspg-dyn-1 {\n  cursor: var(--announcementspg-1-cursor);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
